import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsTriathlonNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M20.76 14.83a4.805 4.805 0 100-9.61c-.546 0-1.087.095-1.6.28l-1.93-3.68h2.12L18.48.17H14.5l1.57 3h-3l-.72-1.35h1.35L12.83.17H8.5l.88 1.65h1.1l1 1.879-.93 1.73a4.784 4.784 0 00-2.63 9.2 4.57 4.57 0 002.06.11.126.126 0 00.06-.01 2.5 2.5 0 00.46-.1 4.862 4.862 0 003.43-3.8h2.1a4.8 4.8 0 004.73 4zm-6.371-5.66h-4l2.02-3.721 1.98 3.72zm-5.18 3.99a3.135 3.135 0 010-6.27c.176-.004.35.013.52.05l-1.2 2.2.87 1.69h2.84a3.135 3.135 0 01-3.03 2.33zm6.9-4.28v.01l-2.16-4.06h2.99l.78 1.48a4.751 4.751 0 00-1.61 2.57zm2.4-1.06l1.28 2.45h1.88l-1.73-3.28a3.18 3.18 0 01.82-.11 3.14 3.14 0 11-2.25.94zM10.79 28.15l-.08-.15h-1.4l-.08.15a1.952 1.952 0 01-3.43 0L5.72 28H4.33l-.08.15a1.93 1.93 0 01-1.72 1.02A1.945 1.945 0 011 28.44v2.05a3.538 3.538 0 001.53.34c.93.01 1.825-.35 2.49-1a3.613 3.613 0 004.99 0 3.626 3.626 0 003.99.68v-2.04a1.95 1.95 0 01-3.21-.32zm0-6l-.08-.15h-1.4l-.08.15a1.952 1.952 0 01-3.43 0L5.72 22H4.33l-.08.15a1.93 1.93 0 01-1.72 1.02A1.945 1.945 0 011 22.44v2.05a3.538 3.538 0 001.53.34c.93.01 1.825-.35 2.49-1a3.613 3.613 0 004.99 0 3.576 3.576 0 002.49 1 3.462 3.462 0 001.5-.33v-2.03a1.95 1.95 0 01-3.21-.32zm0-6l-.08-.15h-1.4l-.08.15a1.952 1.952 0 01-3.43 0L5.72 16H4.33l-.08.15a1.93 1.93 0 01-1.72 1.02A1.945 1.945 0 011 16.44v2.05a3.538 3.538 0 001.53.34c.93.01 1.825-.35 2.49-1a3.613 3.613 0 004.99 0 3.576 3.576 0 002.49 1 3.462 3.462 0 001.5-.33v-2.03a1.95 1.95 0 01-3.21-.32zm20.6 11.45l-4.11-7.68a2.109 2.109 0 00-1.86-1.12h-.01a2.088 2.088 0 00-1.87 1.15l-.12.22a.438.438 0 01-.08-.25v-2.18a1.568 1.568 0 00-2.94-.76l-1.79 3.23-.95.69a2.2 2.2 0 00-.86 1.66 2.26 2.26 0 00.71 1.83l4.96 5.04a8.169 8.169 0 005.76 2.39h.63a2.871 2.871 0 002.53-4.22zm-1.49 1.98a1.188 1.188 0 01-1.04.59h-.63a6.53 6.53 0 01-4.58-1.9l-5-5.07a.685.685 0 01-.2-.54.563.563 0 01.18-.42l1.25-.92 1.81-3.34v1.94a2.108 2.108 0 002.11 2.1h.49l.71-1.31a.467.467 0 01.83-.01l1.03 1.92-1.55.82v1.87l2.32-1.23.55 1.02-1.47.77v1.73l.06.11 2.19-1.15.97 1.82a1.176 1.176 0 01-.03 1.2z"
        fill=""
      />
    </svg>
  )
);
SvgSportsTriathlonNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsTriathlonNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsTriathlonNormalMedium;
